// import { useState } from "react";
// import { useNavigate, Link } from "react-router-dom";
import EmpLayout from "./emp_layout";
import './css/analytics.css';


// analyticsCss = `
//   .an-stats { display:grid; grid-template-columns:repeat(4,1fr); gap:0.75rem; margin-bottom:1.75rem; }
//   .an-stat { background:#fff; border:1px solid rgba(var(--color-text-rgb),0.07); border-radius:4px; padding:1.1rem 1.25rem; }
//   .an-stat-n { font-family: 'DM Sans', sans-serif; font-size:2rem; font-weight:600; color:var(--color-text); line-height:1; margin-bottom:2px; }
//   .an-stat-l { font-size:0.62rem; font-weight:500; letter-spacing:0.08em; text-transform:uppercase; color:#bbb; }
//   .an-stat-trend { font-size:0.7rem; font-weight:500; margin-top:4px; }
//   .an-tup { color:#27ae60; } .an-tneu { color:#bbb; }
//   .an-grid2 { display:grid; grid-template-columns:2fr 1fr; gap:1.5rem; margin-bottom:1.5rem; }
//   .an-card { background:#fff; border:1px solid rgba(var(--color-text-rgb),0.07); border-radius:4px; padding:1.5rem; }
//   .an-card-title { font-family: 'DM Sans', sans-serif; font-size:1.1rem; font-weight:600; color:var(--color-text); margin-bottom:1.25rem; }
//   .an-card-title em { font-style:normal; }
//   .an-bar-list { display:flex; flex-direction:column; gap:0.9rem; }
//   .an-bar-row { }
//   .an-bar-top { display:flex; justify-content:space-between; font-size:0.78rem; margin-bottom:4px; }
//   .an-bar-label { color:#555; font-weight:400; }
//   .an-bar-val { color:var(--color-text); font-weight:500; }
//   .an-bar-bg { height:6px; background:rgba(var(--color-text-rgb),0.07); border-radius:3px; overflow:hidden; }
//   .an-bar-fill { height:100%; background:var(--color-primary); border-radius:3px; }
//   .an-listing-rows { display:flex; flex-direction:column; gap:0; }
//   .an-listing-row { display:flex; align-items:center; gap:0.75rem; padding:0.75rem 0; border-bottom:1px solid rgba(var(--color-text-rgb),0.05); }
//   .an-listing-row:last-child { border-bottom:none; }
//   .an-listing-icon { font-size:1rem; width:32px; height:32px; background:var(--color-bg-subtle); border-radius:3px; display:flex; align-items:center; justify-content:center; flex-shrink:0; }
//   .an-listing-title { font-size:0.82rem; font-weight:500; color:var(--color-text); flex:1; }
//   .an-listing-n { font-family: 'DM Sans', sans-serif; font-size:1.1rem; font-weight:600; color:var(--color-text); }
//   .an-listing-l { font-size:0.6rem; text-transform:uppercase; letter-spacing:0.07em; color:#bbb; text-align:right; }
//   @media(max-width:900px){ .an-stats{grid-template-columns:repeat(2,1fr);} .an-grid2{grid-template-columns:1fr;} }
//   @media(max-width:500px){ .an-stats{grid-template-columns:repeat(2,1fr);} }
// `;

export function Analytics() {
  const trafficSources = [
    { label:"Direct search",     val:42, max:100 },
    { label:"Match recommendations", val:31, max:100 },
    { label:"Category browsing",  val:18, max:100 },
    { label:"Shared links",        val:9,  max:100 },
  ];
  const listingPerf = [
    { icon:"✂️", title:"Senior Hair Stylist", applicants:18, views:142 },
    { icon:"🧖", title:"Lead Esthetician",    applicants:11, views:98  },
    { icon:"💅", title:"Nail Technician",     applicants:24, views:210 },
    { icon:"💼", title:"Salon Receptionist",  applicants:38, views:315 },
  ];

  return (
    <EmpLayout title="Listing" titleEm="Analytics">
      <div className="an-stats">
        {[
          { n:"765",  l:"Total views",       trend:"↑ 23% vs last month", cls:"an-tup" },
          { n:"91",   l:"Total applicants",  trend:"↑ 18 this week",      cls:"an-tup" },
          { n:"3.2%", l:"Apply rate",        trend:"Industry avg: 2.1%",  cls:"an-tup" },
          { n:"4",    l:"Active listings",   trend:"2 paused",            cls:"an-tneu" },
        ].map(s=>(
          <div key={s.l} className="an-stat">
            <div className="an-stat-n">{s.n}</div>
            <div className="an-stat-l">{s.l}</div>
            <div className={`an-stat-trend ${s.cls}`}>{s.trend}</div>
          </div>
        ))}
      </div>

      <div className="an-grid2">
        {/* listing performance */}
        <div className="an-card">
          <div className="an-card-title">Listing <em>performance</em></div>
          <div className="an-listing-rows">
            {listingPerf.map(l=>(
              <div key={l.title} className="an-listing-row">
                <div className="an-listing-icon">{l.icon}</div>
                <div className="an-listing-title">{l.title}</div>
                <div style={{textAlign:"right",flexShrink:0}}>
                  <div className="an-listing-n">{l.applicants}</div>
                  <div className="an-listing-l">Applicants</div>
                </div>
                <div style={{textAlign:"right",flexShrink:0,minWidth:48}}>
                  <div className="an-listing-n">{l.views}</div>
                  <div className="an-listing-l">Views</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* traffic sources */}
        <div className="an-card">
          <div className="an-card-title">Traffic <em>sources</em></div>
          <div className="an-bar-list">
            {trafficSources.map(s=>(
              <div key={s.label} className="an-bar-row">
                <div className="an-bar-top">
                  <span className="an-bar-label">{s.label}</span>
                  <span className="an-bar-val">{s.val}%</span>
                </div>
                <div className="an-bar-bg"><div className="an-bar-fill" style={{width:`${s.val}%`}}/></div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* weekly views chart (simple CSS bars) */}
      <div className="an-card">
        <div className="an-card-title">Views this <em>week</em></div>
        <div style={{display:"flex",gap:"0.5rem",alignItems:"flex-end",height:120,padding:"0 0.25rem"}}>
          {[{d:"Mon",v:28},{d:"Tue",v:45},{d:"Wed",v:38},{d:"Thu",v:62},{d:"Fri",v:55},{d:"Sat",v:30},{d:"Sun",v:18}].map(bar=>(
            <div key={bar.d} style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center",gap:5}}>
              <div style={{fontSize:"0.62rem",color:"#aaa"}}>{bar.v}</div>
              <div style={{width:"100%",background:"var(--color-primary)",borderRadius:"2px 2px 0 0",height:`${(bar.v/70)*90}px`,minHeight:4,opacity:0.85}}/>
              <div style={{fontSize:"0.65rem",color:"#bbb"}}>{bar.d}</div>
            </div>
          ))}
        </div>
      </div>
    </EmpLayout>
  );
}